const loadmainimages = (function () {
  // Private variables
  let loadedDivs = []; // To track dynamically added content
  const isWindows = navigator.userAgent.includes('Windows');
  const isEdge = navigator.userAgent.includes('Edg/');
  let windowsStyles='',
    textContent='',
    windowsEdgeStyles='',
    shadowRootsArray = [];




  // Helper functions
  const fetchContent = async (url) => {
    //   await new Promise(resolve => setCustomTimeout(resolve, 1000));
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch content: ${response.status}`);
    }
    return await response.text();

  };

  const prepareMainContentBody = (originalContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = originalContent;



    // // Add Google Fonts
    // const preconnectLink = document.createElement('link');
    // preconnectLink.rel = 'preconnect';
    // preconnectLink.href = 'https://fonts.googleapis.com';
    // tempDiv.prepend(preconnectLink);

    // const googleFontsLink = document.createElement('link');
    // googleFontsLink.rel = 'stylesheet';
    // googleFontsLink.href = 'https://fonts.googleapis.com/css2?family=Lato:wght@700&family=Open+Sans:wght@400;700&family=Oswald&family=Raleway&family=Roboto:wght@400;700&family=Rubik&display=swap';
    // tempDiv.prepend(googleFontsLink);

    // Add padding styles
    const paddingStyle = document.createElement("style");
    paddingStyle.id = "padding-style";
    paddingStyle.textContent = `
        .main-table-class {
          --leftdivpadding: 0px 25px 0px 25px;
          --righttdpadding: 0px 25px 0px 20px;
          --righttoppadding: calc(10px + var(--rightoffset)) 25px var(--bottomtoppadding) 20px;
          --image-padding-top: 9px;
          --min-div-height:1200px;
        }
      `;
    tempDiv.prepend(paddingStyle);

    const profileImageStyle = document.createElement("style");
    profileImageStyle.textContent = `
        .profileimage-class {
          border-radius: 50%;
          caret-color: transparent;
        }
      `;
    tempDiv.prepend(profileImageStyle);

    // Remove unnecessary attributes and classes
    const mainContentBodyDiv = tempDiv.querySelector("#maincontent-body");
    if (mainContentBodyDiv) {
      mainContentBodyDiv.className = "";
      mainContentBodyDiv.style.textAlign = "left";
      mainContentBodyDiv.querySelectorAll('[contenteditable="true"]').forEach((el) => {
        el.setAttribute("contenteditable", "false");
      });
      mainContentBodyDiv.querySelectorAll('[tabindex]').forEach((el) => el.removeAttribute('tabindex'));

      const mainTable = mainContentBodyDiv.querySelector(
        'table#main-table.main-table-class'
      );

      // Check if the table exists and has the class 'main-table-dark'
      if (mainTable && mainTable.classList.contains('main-table-dark')) {
        mainTable.classList.remove('main-table-dark');
      }

      // Update language for the content
      updateForLanguage(mainContentBodyDiv);
    }

    return tempDiv;
  };

  const extractBodyContent = (html) => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Extract the body content
      return doc.body ? doc.body.innerHTML : "<div>No content found</div>";
    } catch (error) {
      console.error("Error parsing HTML:", error);
      return "<div>Error parsing content</div>";
    }
  };


  const updateMainContentBody = (preparedContent, variation, color = "default", photo) => {
    const tempDiv = preparedContent.cloneNode(true);
    const mainContentBodyDiv = tempDiv.querySelector("#maincontent-body");
    if (mainContentBodyDiv) {
      mainContentBodyDiv.classList.add(
        "theme-base",
        "body-builderjs-layout",
        "mainstyle-only",
        variation,
        color,
        "body-small"
      );

      if (!photo) {
        const profileImage = mainContentBodyDiv.querySelector("img.profileimage-class");
        if (profileImage) {
            profileImage.remove(); // Remove the image element
        }
    }


    }
    return tempDiv.innerHTML;
  };

  const updateForLanguage = (container) => {
    const elements = {
      skills: container.querySelector('#skills'),
      strengths: container.querySelector('#strengths'),
      my_career: container.querySelector('#my_career'),
      summary: container.querySelector('#summary'),
      experience: container.querySelector('#experience'),
      education: container.querySelector('#education'),
      technical_skills: container.querySelector('#technical_skills'),
      languages: container.querySelector('#languages'),
      projects: container.querySelector('#projects'),
      portfolio: container.querySelector('#portfolio'),
      certifications: container.querySelector('#certifications'),
      references: container.querySelector('#references'),
      professional_affiliations: container.querySelector('#professional_affiliations'),
      leadership_awards: container.querySelector('#leadership_awards'),
    };

    const updateIfEmptyElements = {
      resume_name: container.querySelector('#resume_name'),
      resume_title: container.querySelector('#resume_title'),
      resume_phone: container.querySelector('#resume_phone'),
      resume_email: container.querySelector('#resume_email'),
      resume_linkedin: container.querySelector('#resume_linkedin'),
      resume_addr: container.querySelector('#resume_addr'),
    };

    // Update existing fields
    Object.entries(elements).forEach(([key, element]) => {
      if (element) {
        element.textContent = getI18n(key);
      }
    });

    // Update empty fields only
    Object.entries(updateIfEmptyElements).forEach(([key, element]) => {
      if (element && element.textContent.trim() === "") {
        element.textContent = getI18n(key);
      }
    });
  };

  const loadContent = async (sourceUrl) => {
    try {
      const slide1 = document.querySelector("#mainpage-slide1 .content");
      const slide2 = document.querySelector("#mainpage-slide2 .content");
      const slide3 = document.querySelector("#mainpage-slide3 .content");

      if (loadedDivs.length > 0) {
        if (slide1 && loadedDivs[0]) {
          attachToShadowDOM(slide1, loadedDivs[0]);
        }
        if (slide2 && loadedDivs[1]) {
          attachToShadowDOM(slide2, loadedDivs[1]);
        }
        if (slide3 && loadedDivs[2]) {
          attachToShadowDOM(slide3, loadedDivs[2]);
        }
        showSlides(0); // Function to make slides visible
        return;
      }

      console.log("loadedDivs length is 0");

      const html = await fetchContent(sourceUrl);
      let originalContent = extractBodyContent(html);
      const preparedContent = prepareMainContentBody(originalContent);
      originalContent = null;

      if (slide1) {
        const tempDiv1 = document.createElement("div");
        tempDiv1.innerHTML = updatedContent1;
        tempDiv1.style.willChange = "contents";
        tempDiv1.contentEditable = "false";
        loadedDivs[0] = tempDiv1.cloneNode(true); // Store a copy in loadedDivs
        attachToShadowDOM(slide1, tempDiv1);
      }

      if (slide2) {
        const tempDiv2 = document.createElement("div");
        tempDiv2.innerHTML = updatedContent2;
        tempDiv2.style.willChange = "contents";
        tempDiv2.contentEditable = "false";
        loadedDivs[1] = tempDiv2.cloneNode(true); // Store a copy in loadedDivs
        attachToShadowDOM(slide2, tempDiv2);
      }

      if (slide3) {
        const tempDiv3 = document.createElement("div");
        tempDiv3.innerHTML = updatedContent3;
        tempDiv3.style.willChange = "contents";
        tempDiv3.contentEditable = "false";
        loadedDivs[2] = tempDiv3.cloneNode(true); // Store a copy in loadedDivs
        attachToShadowDOM(slide3, tempDiv3);
      }

      showSlides(0); // Function to make slides visible
    } catch (error) {
      console.error("Error fetching or processing content:", error);
    }
  };

  // Helper function to attach content to Shadow DOM
  const attachToShadowDOM = (parentElement, contentElement) => {
    // Clear existing content
    parentElement.innerHTML = "";

    // Create Shadow Root if not already created
    let shadowRoot = parentElement.shadowRoot;
    if (!shadowRoot) {
      shadowRoot = parentElement.attachShadow({ mode: "open" });
      shadowRootsArray.push(shadowRoot);
    }

    // Append content to Shadow Root
    // const fragment = document.createDocumentFragment();
    // const clonedContent = contentElement.cloneNode(true); // Clone the content
    // fragment.appendChild(clonedContent);

    // Append styles if necessary (example)
    const style = document.createElement("style");

    style.textContent = isWindows
    ? (isEdge ? windowsEdgeStyles + textContent : windowsStyles + textContent)
    : textContent;
    //style.textContent = textContent;



    shadowRoot.appendChild(style);

      // Add stylesheets
      const stylesheets = [
        constants.FONT_AWESOME_CSS,
        constants.FONT_AWESOME_STYLE_CSS,
        constants.FONT_AWESOME_STYLE_FREE_CSS,
        constants.GREEN_LEFT_TEMPLATE_CSS
      ];


      stylesheets.forEach((href) => {
        if (!shadowRoot.querySelector(`link[href="${href}"]`)) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          shadowRoot.prepend(link);
        } else {
          console.warn(`Stylesheet already loaded: ${href}`);
      }
      });

    shadowRoot.appendChild(contentElement);


  };



  const isWindowsOS = () => /Win(dows)?/.test(navigator.userAgent);


  const loadContentMultipleSrc = async (sourceUrls) => {
    try {
      const slide1 = document.querySelector("#mainpage-slide1 .content");
      const slide2 = document.querySelector("#mainpage-slide2 .content");
      const slide3 = document.querySelector("#mainpage-slide3 .content");

      if (loadedDivs.length > 0) {
        if (slide1 && loadedDivs[0]) {
          attachToShadowDOM(slide1, loadedDivs[0]);
        }
        if (slide2 && loadedDivs[1]) {
          attachToShadowDOM(slide2, loadedDivs[1]);
        }
        if (slide3 && loadedDivs[2]) {
          attachToShadowDOM(slide3, loadedDivs[2]);
        }
        showSlides(0); // Function to make slides visible
        return;
      }

      // Randomize if more than 3 URLs provided
      let randomizedUrls = sourceUrls;
      if (sourceUrls.length > 3) {
        randomizedUrls = sourceUrls
          .map((url) => ({ url, sort: Math.random() })) // Add random sort key
          .sort((a, b) => a.sort - b.sort) // Sort randomly
          .map(({ url }) => url); // Extract URLs after sorting
      }

      const contentSources = [
        randomizedUrls[0],
        randomizedUrls[1] || randomizedUrls[0], // Reuse the first URL if fewer URLs provided
        randomizedUrls[2] || randomizedUrls[0], // Reuse the first URL if fewer URLs provided
      ];

      // Fetch and prepare content for each slide
      const contents = await Promise.all(
        contentSources.map(async (url) => {
          const html = await fetchContent(url);
          const originalContent = extractBodyContent(html);
          return prepareMainContentBody(originalContent);
        })
      );

      const isWindows = isWindowsOS();

      const updatedContent1 = updateMainContentBody(
        contents[0],
        "lefttdbodythemenophototopbox",
        isWindows ? "bluetopboxmswindows" : "bluetopbox", false
      );

      const updatedContent2 = updateMainContentBody(
        contents[1],
        "lefttdbodybluetheme",
        isWindows ? "greenmswindows" : "green", true
      );

      const updatedContent3 = updateMainContentBody(
        contents[2],
        "lefttdbodywhitebluethemenophotoheaderbulletscenter",
        isWindows ? "bulletsmswindows" : "default", false
      );

      // Attach content to Shadow DOM for each slide
      if (slide1) {
        const tempDiv1 = document.createElement("div");
        tempDiv1.innerHTML = updatedContent1;
        tempDiv1.style.willChange = "contents";
        tempDiv1.contentEditable = "false";
        loadedDivs[0] = tempDiv1.cloneNode(true);
        attachToShadowDOM(slide1, tempDiv1);
      }

      if (slide2) {
        const tempDiv2 = document.createElement("div");
        tempDiv2.innerHTML = updatedContent2;
        tempDiv2.style.willChange = "contents";
        tempDiv2.contentEditable = "false";
        loadedDivs[1] = tempDiv2.cloneNode(true);
        attachToShadowDOM(slide2, tempDiv2);
      }

      if (slide3) {
        const tempDiv3 = document.createElement("div");
        tempDiv3.innerHTML = updatedContent3;
        tempDiv3.style.willChange = "contents";
        tempDiv3.contentEditable = "false";
        loadedDivs[2] = tempDiv3.cloneNode(true);
        attachToShadowDOM(slide3, tempDiv3);
      }

      showSlides(0); // Function to make slides visible
    } catch (error) {
      console.error("Error fetching or processing content from multiple URLs:", error);
    }
  };





  const showSlides = (delay = 0) => {
    const slides = document.querySelectorAll(".hidden-content");
    setCustomTimeout(() => {
      slides.forEach(slide => {
        slide.classList.remove("hidden-content");
        slide.style.visibility = "visible"; // Ensures smooth transitions
      });
    }, delay);
  };


  // Public `init` method
  const init = async (sourceUrls) => {
    setStyleText();
    if (Array.isArray(sourceUrls)) {
      await loadContentMultipleSrc(sourceUrls);
    } else {
      await loadContent(sourceUrls);
    }
  };

  // Public `unload` method
  const unload = () => {
    // Clear the content of dynamically loaded divs
    // Remove content from slides
    windowsStyles='';
    textContent='',
    windowsEdgeStyles='';

    // Cleanup all Shadow Roots
  shadowRootsArray.forEach(shadowRoot => {
    if (shadowRoot) {
      // Remove all children inside the shadowRoot
      while (shadowRoot.firstChild) {
        shadowRoot.removeChild(shadowRoot.firstChild);
      }

      // Remove all event listeners from elements inside shadowRoot
      const shadowElements = shadowRoot.querySelectorAll("*");
      shadowElements.forEach(el => {
        el.replaceWith(el.cloneNode(true)); // Removes event listeners
      });
    }
  });

  // Clear the stored shadow roots
  shadowRootsArray.length = 0;

    const slide1 = document.querySelector("#mainpage-slide1 .content");
    const slide2 = document.querySelector("#mainpage-slide2 .content");
    const slide3 = document.querySelector("#mainpage-slide3 .content");

    if (slide1) {
      removeAllChildrenAndStyles(slide1);
    }

    if (slide2) {
      removeAllChildrenAndStyles(slide2);
    }

    if (slide3) {
      removeAllChildrenAndStyles(slide3);
    }
  };


  const setStyleText = () => {
  // Define Windows-specific styles showing light colors because windows black is very black
  windowsStyles = `
  :host {
     --color-black: #222;
    --color-white: #dcdcdc;
  }

  /* Edge-specific styles */
@supports (-ms-ime-align: auto) {
  :host {
   --color-black: #7c7c7c;
    --color-white: #dbdbdb;
  }
}

/* Firefox-specific styles */
@-moz-document url-prefix() {
  :host {
   --color-black: #7c7c7c;
    --color-white: #dbdbdb;
  }
}
  `;


windowsEdgeStyles = `
    :host {
    --color-black: #7c7c7c;
      --color-white: #dbdbdb;
    }
  `;

textContent = `

/* /** Slider Container */

.splide_is_active {

  border: 1px solid var( --a-color-blue) !important;
  box-shadow: 0px 0px 0rem 1px #ffffff;
}

.mainslider-filter-container {
  margin-bottom: 20px;
  text-align: center;
}

.mainslider-filter-container label {
  margin-right: 10px;
}

.mainslider-filter-container select {
  padding: 3px;
  font-size: 14px;
}

.mainslider-button-container {
  text-align: center;
  margin-bottom: 20px;
}

.mainslider-button-container button {
  padding: 10px 20px;
  margin: 5px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  transition: background-color 0.3s;
}

.mainslider-button-container button:hover {
  background-color: #0056b3;
}

.mainslider-wrapper {
  position: relative;
  max-width: 100%;
  overflow: hidden;
  /* border: 1px solid #ddd; */
  border-radius: 0px;
  background-color: var(--slider-top);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 125px);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}



.slide-topdiv{
  width: 192px;
  overflow: hidden;

}

.mainslider-container {
  flex-grow: 1;
  display: grid;
  gap: 25px;
  row-gap: 25px;
  grid-template-columns: repeat(auto-fit, 195px);
  grid-auto-rows: 353px;
  align-items: start;
  justify-items: start;
  background-color: var(--slider-top);
  overflow-y: auto;
  overflow-x: hidden;
  filter: brightness(var(--slider-brightness));
}

.mainslider-container::-webkit-scrollbar {
  display: none;
}

/* For Firefox */
.mainslider-container {
  scrollbar-width: none; /* Disables the scrollbar in Firefox */
}

/* For Internet Explorer/Edge Legacy */
.mainslider-container {
  -ms-overflow-style: none; /* Hides scrollbars in IE/Edge Legacy */
}




.mainslider-item.selected {
  border: 3px solid #007bff;
}

.mainslider-details {
  margin-top: 10px;
  text-align: center;
}


.mainslider-item {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 1px solid var(--resume-border);
}

.mainslider-container .mainslider-item:focus {
  outline: none;
}

.mainslider-container .mainslider-item:focus-visible {
  outline: none;

}


.mainslider-container.mobile .mainslider-item:last-child {
  margin-right: 60px; /* Ensures last slide isn't cut off on mobile */
}


.mainslider-container.mobile {
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
  padding: 0px 10px; /* Added padding on both sides to account for scrolling space */
  overflow-x: auto;
  overflow-y: hidden;
}


.mainslider-filter-attributes-dropdown{
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 10px;
  background-color: var(--slider-top);
  border: 1px solid var(--resume-border);
  color: var(--text-primary);
  -webkit-text-fill-color: var(--text-primary) !important;
  caret-color: var(--text-primary) !important;

}


.th_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-right: 0px;
  margin-left: 0px;

}


.bottom-of-slide {
  background-color: var(--resume-background-color);
  z-index: 2;

  padding: 0px 11px 15px 11px;
  margin-top: -25px;
}

.th_square-container-font {
  z-index: 6;
  display: flex;
  justify-content: space-between;

  margin-top: 0px;
  height: 40px;
  padding: 10px 7px 10px 7px;
  background-color: #fff;
  border-top: 1px solid var(--resume-border);
  margin: 0px;
}

.th_square-container {
  z-index: 5;
  display: flex;
  justify-content: space-between;

  margin: 0 auto;
  height: 30px;
  /* margin-top: 30px; */
  /* margin-bottom: 10px; */
  background-color: #fff;
  padding: 10px 7px 10px 7px;
}

.middle-text {
  z-index:2;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  font-size: 14px;
  width: 100%;
  color: var(--text-primary);
  background-color: var(--resume-background-color);
  border-top: 1px solid var(--resume-border);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* Ensures text stays in a single line */
}


.th_square-container2row {
  background-color: var(--resume-background-color);
  width: 172px;
}

.th_square-container2row.coverletter-item{
  background-color: var(--resume-background-color);
  width: 166px;
}



.th_square {
  width: 22px; /* Adjusted width to fit within the thumbnail */
  height: 22px; /* Adjusted height to fit within the thumbnail */
  background-color: red; /* Default background color for squares */
  margin: 0 5px; /* Adjusted margin for spacing between squares */
}

.th_square a {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 18px;
  border: 1px solid var(--resume-border);
  cursor: pointer;
}

.th_square:hover {
  transform: scale(1.4); /* Zoom out effect on hover */
}

.th_active_color {
  outline: 1px solid var(--a-color-blue);
  outline-offset: 2px;
}


.theme-base {
    --thumbnail-font-color: var(--color-secondary-background);
}







.left-collapsable-templates-light {
    width: 100%;
  }

  .mainslider-container .mainslider-item {
    overflow: visible;

  }

  .mainslider-item div.content {
    transform: scale(.476, .45);
    transform-origin: top left;
    width: 210%;
    height: 190%;
    margin-top: 40px;
    background-color: var(--color-secondary-background);
  }

  .mainslider-item div.content {
    transform: scale(.476, .45);
    transform-origin: top left;
    width: 210%;
    height: 190%;
    margin-top: 30px;
    background-color: var(--color-secondary-background);
  }

  .mainslider-item div.content {
    padding: 2px 20px 0px 30px;
}


  .left-collapsable-templates-light {
    background-color: var(--color-secondary-background);
    height: 100%;

  }

  .border-1px-solid {
    border: 1px solid var(--secondary-background-border-color);

  }

  .mainslider-wrapper {
    background-color: var(--slider-background-overwite);
    border-radius: 25px;
  }

  .mainslider-container.mobile {
    gap: 30px;
    padding: 2px 22px;
    margin-top: 15px;

  }

  .font-label,
  .color-label {
    flex-grow: 1;
    padding-right: 5px;
  }

  .th_square-container2row {
    width: 80%;
    display: flex;

  }

  .th_square a {
    border: 1px solid var(--secondary-background-border-color);
  }

  .middle-text {
    background-color: var(--color-secondary-background);
    border-top: 0px;
    padding: 0px;

  }

  #mainslider-arrow-container {
    display: none !important;
  }

  .maintop-div {
    padding: 0px 0px 15px 0px;
    border: 1px solid var(--secondary-background-border-color);
    display: flex;
    flex-direction: row-reverse;
    padding: 0;
    z-index: 3;
  }

  .bottom-of-slide {
    display: none;
  }

  .th_square-container-font {
    border-top: 0px;
  }

  .middle-text {
    display: none;
  }

  .splide_is_active {
    border: 0px !important;
    box-shadow: none;
  }

  .applytheme {
    display: none;
  }

  div#image-carousel-div {
    border-radius: 25px !important;
    background-color: var(--slider-background-overwite);
    border: 1px solid var(--secondary-background-border-color);
    padding: 0px;
    margin: 0px;
  }

  .mainslider-item {
    border: 0px;
  }

  .mainslider-container {
    background-color: var(--color-secondary-background);
  }

  .th_square-container2row {
    background-color: var(--color-secondary-background);
  }

  .sliderstyle-only {
    margin: 0px;
    margin-top: 20px;
    border: 0px solid var(--secondary-background-border-color);
    box-shadow: 0 14px 1rem var(--card-boxshadow-image-color-first-path);
  }


  .tox-toolbar__primary_left {
    background-color: var(--color-secondary-background);
    display: none;
  }

  .hidden-content {
    visibility: hidden; /* Prevents flickering */
    opacity: 0; /* Makes it invisible but allows smooth transitions */
  }


  .content-div {
    flex: 1;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
  }

  .content-div1 {
    background-color: var(--body-background-color);
  }

  .content-div2 {
    background-color: var(--body-background-color);
  }

  .content-div3 {
    background-color: var(--body-background-color);
  }

  .content-div div.content {
    transform-origin: top left;
    transform: scale(.22, .21) translateZ(0);;
    width: 455%;
    height: 532%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--body-background-color);
  }

  .content-div1 div.content {}

  .content-div2 div.content {
    transform: scale(.22, .205);
  }

  .content-div3 div.content {}


  .mainstyle-only {
    margin: 0px;
    border: 0px solid var(--secondary-background-border-color);


  }

  .content-image-style {
    display: flex;
    align-items: center;
    width: 250px;
    height: 350px;
  }



  .mainslider-filter-attributes-dropdown {
    background-color: var(--color-secondary-background);
  }

@media (max-width: 1260px) {
    .left-collapsable-templates-light {
      display: block;
    }
  }

  @media (min-width: 768px) {
    .content-lefttdbodywhitebluethemenophotoheadercenter {
      transform: scale(0.476, 0.471) !important;
    }

    .content-lefttdbodybluetheme {
      transform: scale(0.476, 0.463) !important;
    }

    .content-lefttdbodywhitetheme {
      transform: scale(0.476, 0.4635) !important;
    }

    .content-lefttdbodythemenophotoorange {
      transform: scale(0.476, 0.437) !important;
    }

    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
      transform: scale(0.476, 0.496) !important;
    }

    .content-lefttdbodythemenophototopbox {
      transform: scale(0.476, 0.4765) !important;
    }

    .content-lefttdbodygreentheme {
      transform: scale(0.476, .4655) !important;
    }

    .content-lefttdbodywhitebluethemenophoto {
      transform: scale(0.476, 0.4805) !important;
    }

    .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
      transform: scale(0.476, 0.472) !important;
    }

    .content-lefttdbodywhitebluethemenophotoheaderbullets {
      transform: scale(0.476, 0.472) !important;
    }


  }


  @media (max-width: 767px) {

    .left-collapsable-templates-light {
      height: 405px;
      width: calc(-22px + 100vw);
      margin-left: 0px;
      margin-bottom: 5px;
    }

    .font-label {
      display: none;
    }

    .color-label {
      padding-right: 10px;
    }

    .maintop-div {
      flex-direction: column;
      padding: 0 0 15px 0;

    }

    .th_square-container-font {
      display: none;
    }

    .th_square-container2row {
      width: 100%;
    }


    .mainslider-container .mainslider-item {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

    .mainslider-container.mobile {
      gap: 10px;
      padding: 2px 7px;
      width: calc(-20px + 100vw);
      height: 260px;

    }


    .sliderstyle-only {
      margin: 0px;
      border: 0px solid var(--secondary-background-border-color);
      box-shadow: 0 14px 1rem var(--card-boxshadow-image-color-first-path);

    }


    .mainslider-item div.content {
      transform: scale(.322);
      transform-origin: top left;
      width: 295%;
      height: 532%;
      position: absolute;
      top: 0;
      left: 0;
      margin-top: 70px;
      background-color: var(--resume-background-color);
    }


  }

  .margintablemarginscale {
    margin-left: 0px !important;
}

#main-table h1 {
    padding-bottom: 10px !important;
}

.main-table-class {
 border-spacing:0px;
  }




/* **/

  `;
  };


  // Return public methods
  return {
    init,
    unload,
  };
})();

export default loadmainimages;
